import React, { useEffect, useState }                               from 'react';
import { Container, Group, Loader, Paper, SimpleGrid, Text, Title } from '@mantine/core';
import { PropertyItemCard }                                         from '@features/common/cards/PropertyItem/PropertyItemCard';
import useUserData                                                  from '@features/common/hooks/use-user-data';
import useIsMounted                                                 from '@hooks/use-is-mounted';
import { S3_PROPERTY_BUCKET_URL }                                   from '@utils/network-utils';
import { getAddressText }                                           from '@utils/dxb-utils';
import { useGetUserFavPropertiesQuery }                             from '../../../generated/graphql';
import useStyles                                                    from './FavoritesPageLanding.styles';


export const FavoritesPageLanding: React.FC = () => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const { getUserEmail } = useUserData();

    const [localData, setLocalData] = useState([])
    const { data, loading, error } = useGetUserFavPropertiesQuery(
        {
            variables: { email: getUserEmail() },
            fetchPolicy: 'network-only'
        });

    useEffect(() => {

        if (data?.getUserFavProperties) {
            setLocalData(data.getUserFavProperties)
        }

    }, [data]);

    const propertyItems = localData.map((property) => {

        const thumbUrl = property?.images?.filter((img) => img.type === 'thumb' && img)[0]?.src;

        return (
            <div key={property.id}>
                <PropertyItemCard
                    propertyId={property.id}
                    name={property.name}
                    thumb={thumbUrl && `${S3_PROPERTY_BUCKET_URL}/${thumbUrl}`}
                    address={getAddressText(property.location)}
                    amount={property.priceDetails.pricePerNight}
                    currency="AED"
                    details={property.details}
                    isFeatured={property.settings.is_featured}
                    isPropertyPage={true}
                    settings={property.settings}
                    isFavVisible={true}
                    isFav={true}
                />
            </div>
        );

    });

    return isMounted && (
        <Container className={classes.favoritesLanding}>

            <>
                <Group className={classes.titleGroup}>
                    <Title className={classes.h1} order={1}>Your Favourite Properties</Title>
                    <Title className={classes.h2} order={2}>Choose from the properties you like and book your experience now</Title>
                </Group>

                {/*{error && JSON.stringify(error)}*/}
                {error || data?.getUserFavProperties?.length === 0 &&
                    <Paper mt={30} className={classes.paper}>
                        <Title className={classes.h1} order={1}>No favorite properties found</Title>
                        <Text pt={20} pb={20}>You have not added any properties to this list. Click the heart icon on the property you like to add it to your favorites.</Text>
                    </Paper>
                }

                {loading && <Paper mt={30} className={classes.progress}><Loader color="#f39c12" variant="dots" size="sm"/></Paper>}
                {/*{loading && <Progress color="#f39c12" radius="xl" size="xl" value={100} striped={false} animate={false}/>}*/}

                <SimpleGrid
                    mt={20}
                    mb={20}
                    cols={3}
                    breakpoints={[
                        { maxWidth: 'xl', cols: 3, spacing: 'sm' },
                        { maxWidth: 'md', cols: 2, spacing: 'sm' },
                        { maxWidth: 'sm', cols: 1, spacing: 0 },
                    ]}
                >
                    {propertyItems}
                </SimpleGrid>
            </>

        </Container>
    )

}
